import React from "react";
import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Card from "react-bootstrap/Card";
import CardContent from "@mui/material/CardContent";

const ServiceCardSkeleton = ({ count = 6 }) => {
    return (
        <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 12, sm: 12, lg: 4, md: 6 }}
            className="trackers-area mt-4"
        >
            {Array.from({ length: count }).map((_, index) => (
                <Grid
                    key={`skeleton-${index}`}
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 4,
                    }}
                >
                    <Card
                        className="dashboard-tree-source-item lead-item service-item"
                        style={{
                            boxShadow: "none",
                            border: "1px solid #E7E7E7",
                            borderRadius: "10px",
                            marginBottom: "20px",
                            position: "relative",
                        }}
                    >
                        {/* Edit icon skeleton */}
                        <div
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                zIndex: 10,
                            }}
                        >
                            <Skeleton
                                variant="circular"
                                width={28}
                                height={28}
                            />
                        </div>

                        {/* Header with icon and title */}
                        <CardContent
                            style={{ padding: "20px" }}
                            className="d-flex items-center justify-start"
                        >
                            <div className="mr-3">
                                <Skeleton
                                    variant="rectangular"
                                    width={32}
                                    height={32}
                                    sx={{ borderRadius: "4px" }}
                                />
                            </div>
                            <Skeleton
                                variant="text"
                                width={150}
                                height={28}
                                sx={{ fontSize: "1.125rem" }}
                            />
                        </CardContent>

                        {/* Service info section */}
                        <CardContent
                            style={{ padding: "20px", paddingTop: "0" }}
                            className="d-flex items-center justify-start"
                        >
                            <div
                                className="lead-service-info-area"
                                style={{ width: "100%" }}
                            >
                                {/* Name field */}
                                <div style={{ marginBottom: "12px" }}>
                                    <Skeleton
                                        variant="text"
                                        width={60}
                                        height={14}
                                        sx={{
                                            fontSize: "0.75rem",
                                            marginBottom: "4px",
                                        }}
                                    />
                                    <Skeleton
                                        variant="text"
                                        width="80%"
                                        height={18}
                                        sx={{ fontSize: "0.875rem" }}
                                    />
                                </div>

                                {/* URL field */}
                                <div style={{ marginBottom: "12px" }}>
                                    <Skeleton
                                        variant="text"
                                        width={40}
                                        height={14}
                                        sx={{
                                            fontSize: "0.75rem",
                                            marginBottom: "4px",
                                        }}
                                    />
                                    <Skeleton
                                        variant="text"
                                        width="90%"
                                        height={18}
                                        sx={{ fontSize: "0.875rem" }}
                                    />
                                </div>

                                {/* Method field */}
                                <div style={{ marginBottom: "12px" }}>
                                    <Skeleton
                                        variant="text"
                                        width={70}
                                        height={14}
                                        sx={{
                                            fontSize: "0.75rem",
                                            marginBottom: "4px",
                                        }}
                                    />
                                    <Skeleton
                                        variant="text"
                                        width={80}
                                        height={18}
                                        sx={{ fontSize: "0.875rem" }}
                                    />
                                </div>
                            </div>
                        </CardContent>

                        {/* Status badge */}
                        <CardContent
                            style={{ padding: "20px", paddingTop: "0" }}
                            className="d-flex items-center justify-start"
                        >
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={36}
                                sx={{ borderRadius: "6px" }}
                            />
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default ServiceCardSkeleton;

